import React from "react";
import { Box } from "@mui/material";
import { HeaderInfo } from "../../types";
import DataTable from "./data_table";
import TableLoader from "./table_loader";

interface TableResultsProps {
  headersInfo: HeaderInfo[];
  selectedTab: string;
  onScroll: (e: React.UIEvent) => void;
  onViewAllHandler: (header: HeaderInfo) => void;
  isScrollOn: boolean;
  handleClose?: () => void;
}

const TableResults: React.FC<TableResultsProps> = ({
  headersInfo,
  selectedTab,
  onScroll,
  onViewAllHandler,
  isScrollOn,
  handleClose,
}) => {
  return (
    <Box
      id="search-result-tables"
      className="search-result-tables scroll h-scroll"
      onScroll={onScroll}
    >
      <Box className="search-tab-results">
        {headersInfo.map((data, index) => {
          const hasRows = data?.data?.length > 0;
          if (selectedTab.length === 0 || selectedTab === data.key) {
            return data.isApiCall ? (
              <DataTable
                key={index}
                data={data}
                hasRows={hasRows}
                onViewAllHandler={onViewAllHandler}
                handleClose={handleClose}
              />
            ) : (
              <TableLoader key={index} tableCount={1} />
            );
          }

          return null;
        })}
      </Box>

      {/* Scroll loading state */}
      {isScrollOn && <TableLoader tableCount={1} removeHeader={true} />}
    </Box>
  );
};

export default TableResults;
